import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getPaymentServiceEndPoint } from "./base-url/api-constants";
import { readCookie } from "../Util/helper";

class PaymentService {
  PaymentService(url: string) {
    return getPaymentServiceEndPoint(url);
  }
  getPlans(data: any) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const createPaymentEndpoint = this.PaymentService(`${endPoints.paymentService.GET_PLANS}`);
    return apiService.post(createPaymentEndpoint, data, headers);
  }
  paymentProcess(data: any) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const createPaymentProcessEndpoint = this.PaymentService(`${endPoints.paymentService.PAYMENT_PROCESS}`);
    return apiService.post(createPaymentProcessEndpoint, data, headers);
  }
  getSkuDetails(skuId: string, locale: string) {
    //appLogger.log("inside get Sku Details ");
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    var createSkuDetailsEndpoint = `${endPoints.paymentService.GET_SKU_DETAILS}/${skuId}`;
    if (!!locale) {
      createSkuDetailsEndpoint = `${endPoints.paymentService.GET_SKU_DETAILS}/${skuId}/${locale}`;
    }
    const getSkuDetailsEndpoint = this.PaymentService(createSkuDetailsEndpoint);
    return apiService.get(getSkuDetailsEndpoint, null, headers);
  }
  isCardInBadBins(bin: any) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    var badbinEndPoint = `${endPoints.paymentService.BAD_BINS}?bin=${bin}`;
    const getSkuDetailsEndpoint = this.PaymentService(badbinEndPoint);
    return apiService.get(getSkuDetailsEndpoint, null, headers);
  }
  CreatePaymentIntent(data: any) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const paymentIntentEndPoint = this.PaymentService(`${endPoints.paymentService.PAYMENT_INTENT}`);
    return apiService.post(paymentIntentEndPoint, data, headers);
  }
  CalculatePricing(skuGuid: string, currency: string, skuCategory: string, users: string) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const PricingEndpoint = this.PaymentService(
      `${endPoints.paymentService.GET_GUSETUSER_PRICING.replace(":skuguid", skuGuid)
        .replace(":currency", currency)
        .replace(":skucategory", skuCategory)
        .replace(":users", users)}`
    );
    return apiService.get(PricingEndpoint, null, headers);
  }
  getTaxEstimate(stateCode: string, zipCode: string, planAmount: any) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const taxMatrixEndPoint = this.PaymentService(
      `${endPoints.paymentService.TAX_MATRIX.replace(":stateCode", stateCode)
        .replace(":zipCode", zipCode)
        .replace(":planAmount", planAmount)}`
    );
    return apiService.get(taxMatrixEndPoint, null, headers);
  }
}

export default new PaymentService();
